import { Component } from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-public-place',
  imports: [
    RouterOutlet
  ],
  templateUrl: './place.component.html'
})
export class PlaceComponent {

}
